var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "inputUserDataSection", class: { isPc: !_vm.isSp } },
    [
      _c("TitleText", {
        attrs: { id: "titleArea", text: "登録情報入力", "wide-sp": true },
      }),
      _vm._v(" "),
      _c("ServerErrorArea", {
        staticClass: "serverErrorArea",
        attrs: {
          "error-type": _vm.errorType,
          "server-error-list": _vm.serverErrorList,
        },
      }),
      _vm._v(" "),
      _c("InputName", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          id: "nameInputArea",
          "error-from-outer-sei": _vm.errors.name.sei,
          "error-from-outer-mei": _vm.errors.name.mei,
          "name-input-type": _vm.FULL_NAME_TYPE.KANJI,
          "name-object": _vm.inputs.name,
          "watch-name-object-flg": _vm.actionWatchNameObjectFlg,
          "area-label": "名前",
          required: "",
        },
        on: {
          change: function ($event) {
            return _vm.onChangeGeneral("name", $event)
          },
          watchValidationSei: function ($event) {
            return _vm.watchGeneralNestedValidation("name", "sei", $event)
          },
          watchValidationMei: function ($event) {
            return _vm.watchGeneralNestedValidation("name", "mei", $event)
          },
          focusSei: function ($event) {
            return _vm.onFocusGeneralNested("name", "sei")
          },
          focusMei: function ($event) {
            return _vm.onFocusGeneralNested("name", "mei")
          },
          blurSei: function ($event) {
            return _vm.onBlurGeneralNested("name", "sei")
          },
          blurMei: function ($event) {
            return _vm.onBlurGeneralNested("name", "mei")
          },
        },
      }),
      _vm._v(" "),
      _c("InputName", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          id: "hiraganaNameInputArea",
          "error-from-outer-sei": _vm.errors.hiraganaName.sei,
          "error-from-outer-mei": _vm.errors.hiraganaName.mei,
          "name-input-type": _vm.FULL_NAME_TYPE.HIRAGANA,
          "name-object": _vm.inputs.hiraganaName,
          "watch-name-object-flg": _vm.actionWatchNameKanaObjectFlg,
          "area-label": "ふりがな",
          required: "",
        },
        on: {
          change: function ($event) {
            return _vm.onChangeGeneral("hiraganaName", $event)
          },
          watchValidationSei: function ($event) {
            return _vm.watchGeneralNestedValidation(
              "hiraganaName",
              "sei",
              $event
            )
          },
          watchValidationMei: function ($event) {
            return _vm.watchGeneralNestedValidation(
              "hiraganaName",
              "mei",
              $event
            )
          },
          focusSei: function ($event) {
            return _vm.onFocusGeneralNested("hiraganaName", "sei")
          },
          focusMei: function ($event) {
            return _vm.onFocusGeneralNested("hiraganaName", "mei")
          },
          blurSei: function ($event) {
            return _vm.onBlurGeneralNested("hiraganaName", "sei")
          },
          blurMei: function ($event) {
            return _vm.onBlurGeneralNested("hiraganaName", "mei")
          },
        },
      }),
      _vm._v(" "),
      _c("SelectYmd", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          id: "birthdayInputArea",
          "error-from-outer": _vm.errors.birthday,
          "area-label": "生年月日",
          required: "",
        },
        on: {
          watchValidation: function ($event) {
            return _vm.watchGeneralValidation("birthday", $event)
          },
          change: function ($event) {
            return _vm.onChangeGeneral("birthday", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("SelectGender", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          id: "genderInputArea",
          "validate-at-mount": true,
          "gender-expression": _vm.inputs.genderExpression,
          "error-from-outer": _vm.errors.gender,
          "error-from-outer-expression": _vm.errors.genderExpression,
          required: "",
        },
        on: {
          watchValidation: function ($event) {
            return _vm.watchGeneralValidation("gender", $event)
          },
          watchInputTextValidation: _vm.watchInputTextValidation,
          inputText: _vm.inputText,
          changeInputValue: _vm.changeInputValue,
          focusGender: _vm.focusGender,
        },
        model: {
          value: _vm.inputs.gender,
          callback: function ($$v) {
            _vm.$set(_vm.inputs, "gender", $$v)
          },
          expression: "inputs.gender",
        },
      }),
      _vm._v(" "),
      _c("InputWithLabel", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          id: "telInputArea",
          "error-from-outer": _vm.errors.tel,
          "area-label": "電話番号",
          "input-type": "text",
          placeholder: "例）0312345678",
          required: "",
          "validation-list": [
            _vm.VALIDATION_LIST.EMPTY,
            _vm.VALIDATION_LIST.TEL,
          ],
        },
        on: {
          watchValidation: function ($event) {
            return _vm.watchGeneralValidation("tel", $event)
          },
          focus: _vm.onFocusTel,
        },
        model: {
          value: _vm.inputs.tel,
          callback: function ($$v) {
            _vm.$set(_vm.inputs, "tel", $$v)
          },
          expression: "inputs.tel",
        },
      }),
      _vm._v(" "),
      "postal" in _vm.inputs
        ? _c("PostalNumber", {
            staticClass: "inputArea",
            class: { isPc: !_vm.isSp },
            attrs: {
              id: "postalInputArea",
              "error-from-outer": _vm.errors.postal,
              "postal-click-flg": _vm.postalClickFlg,
              required: "",
            },
            on: {
              onClick: _vm.onClickPostalNumberSuggest,
              watchValidation: function ($event) {
                return _vm.watchGeneralValidation("postal", $event)
              },
            },
            model: {
              value: _vm.inputs.postal,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "postal", $$v)
              },
              expression: "inputs.postal",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      "pref" in _vm.inputs
        ? _c("SelectBoxArea", {
            staticClass: "inputArea",
            class: { isPc: !_vm.isSp },
            attrs: {
              id: "prefInputArea",
              "area-label": "都道府県",
              "select-list": _vm.TODOFUKEN_LIST,
              "input-value": _vm.inputs.pref,
              placeholder: "都道府県を選択",
              required: "",
              "error-from-outer": _vm.errors.pref,
            },
            on: {
              change: _vm.onChangePref,
              watchValidation: function ($event) {
                return _vm.watchGeneralValidation("pref", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      "address1" in _vm.inputs
        ? _c("InputWithLabel", {
            staticClass: "inputArea",
            class: { isPc: !_vm.isSp },
            attrs: {
              id: "address1InputArea",
              "error-from-outer": _vm.errors.address1,
              "area-label": "市区町村",
              "input-type": "text",
              placeholder: "例）千代田区丸の内",
              required: "",
              "validation-list": [
                _vm.VALIDATION_LIST.EMPTY,
                _vm.VALIDATION_LIST.ADDRESS,
              ],
              max: 36,
            },
            on: {
              watchValidation: function ($event) {
                return _vm.watchGeneralValidation("address1", $event)
              },
              focus: function ($event) {
                return _vm.onFocusGeneral("address1")
              },
              blur: function ($event) {
                return _vm.onBlurGeneral("address1")
              },
            },
            model: {
              value: _vm.inputs.address1,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "address1", $$v)
              },
              expression: "inputs.address1",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      "address2" in _vm.inputs
        ? _c("InputWithLabel", {
            staticClass: "inputArea",
            class: { isPc: !_vm.isSp },
            attrs: {
              id: "address2InputArea",
              "error-from-outer": _vm.errors.address2,
              "area-label": "番地",
              "input-type": "text",
              placeholder: "以降の住所を入力",
              required: "",
              max: 15,
              "validation-list": [
                _vm.VALIDATION_LIST.EMPTY,
                _vm.VALIDATION_LIST.ADDRESS,
              ],
            },
            on: {
              watchValidation: function ($event) {
                return _vm.watchGeneralValidation("address2", $event)
              },
              focus: function ($event) {
                return _vm.onFocusGeneral("address2")
              },
              blur: function ($event) {
                return _vm.onBlurGeneral("address2")
              },
            },
            model: {
              value: _vm.inputs.address2,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "address2", $$v)
              },
              expression: "inputs.address2",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      "address3" in _vm.inputs
        ? _c("InputWithLabel", {
            staticClass: "inputArea",
            class: { isPc: !_vm.isSp },
            attrs: {
              id: "address3InputArea",
              "error-from-outer": _vm.errors.address3,
              "area-label": "建物名・部屋番号",
              "input-type": "text",
              placeholder: "建物名が含まれる場合は入力",
              optional: "",
              max: 25,
              "validation-list": [_vm.VALIDATION_LIST.ADDRESS],
            },
            on: {
              watchValidation: function ($event) {
                return _vm.watchGeneralValidation("address3", $event)
              },
              focus: function ($event) {
                return _vm.onFocusGeneral("address3")
              },
              blur: function ($event) {
                return _vm.onBlurGeneral("address3")
              },
            },
            model: {
              value: _vm.inputs.address3,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "address3", $$v)
              },
              expression: "inputs.address3",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("SelectBoxArea", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          id: "zokuseiInputArea",
          "area-label": "学年 (高校/その他)",
          "select-list": _vm.ZOKUSEI_LIST,
          placeholder: "学年を選択",
          required: "",
          "error-from-outer": _vm.errors.zokusei,
        },
        on: {
          change: _vm.onChangeZokusei,
          watchValidation: function ($event) {
            return _vm.watchGeneralValidation("zokusei", $event)
          },
        },
      }),
      _vm._v(" "),
      "schoolName" in _vm.inputs
        ? _c("SchoolName", {
            staticClass: "inputArea",
            class: { isPc: !_vm.isSp },
            attrs: {
              id: "schoolNameInputArea",
              "selected-school-code": _vm.inputsSchoolCode,
              "pref-code": _vm.inputs.pref,
              "error-from-outer": _vm.errors.schoolName,
              "school-name-valid-check-flg": _vm.schoolNameValidCheckFlg,
              required: _vm.isSchoolNameRequire,
              optional: !_vm.isSchoolNameRequire,
              "confirmed-school-value": _vm.confirmedSchoolValue,
            },
            on: {
              handleSchoolCd: _vm.handleSchoolCd,
              onClick: _vm.onClickSchoolNameSuggest,
              watchValidation: function ($event) {
                return _vm.watchGeneralValidation("schoolName", $event)
              },
              setConfirmValue: function ($event) {
                _vm.confirmedSchoolValue = $event
              },
            },
            model: {
              value: _vm.inputs.schoolName,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "schoolName", $$v)
              },
              expression: "inputs.schoolName",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("InputWithLabel", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          id: "userNameInputArea",
          "error-from-outer": _vm.errors.userName,
          "area-label": "ユーザー名",
          "input-type": "text",
          placeholder: "ログインに使用するユーザー名を入力",
          required: "",
          "caption-text":
            "ユーザー名は半角英数字と一部半角記号（-_.）のみ使用可能です。",
          "validation-list": [
            _vm.VALIDATION_LIST.EMPTY,
            _vm.VALIDATION_LIST.USER_NAME,
          ],
        },
        on: {
          watchValidation: _vm.watchUserNameValidation,
          focus: _vm.onFocusUserName,
        },
        model: {
          value: _vm.inputs.userName,
          callback: function ($$v) {
            _vm.$set(_vm.inputs, "userName", $$v)
          },
          expression: "inputs.userName",
        },
      }),
      _vm._v(" "),
      _c("PasswordDoubleCheck", {
        staticClass: "inputArea",
        class: { isPc: !_vm.isSp },
        attrs: {
          "error-from-outer-password1": _vm.errors.password.password1,
          "error-from-outer-password2": _vm.errors.password.password2,
          "area-label": "パスワード",
          "input-type": "password",
          placeholder: "パスワードを入力",
          required: "",
          "prop-password1": _vm.inputs.password.password1,
          "prop-password2": _vm.inputs.password.password2,
          "trim-space-start-end": "",
          "user-name": _vm.inputs.userName,
          "email-account": _vm.mailAddress.emailAccount,
          "force-validation-check-flg": _vm.forcePasswordValidationCheckFlg,
          "caption-text":
            "半角英字と半角数字の両方を組み合わせた6文字以上で入力してください。",
        },
        on: {
          change: function ($event) {
            return _vm.onChangeGeneral("password", $event)
          },
          watchValidationPassword1: function ($event) {
            return _vm.watchGeneralNestedValidation(
              "password",
              "password1",
              $event
            )
          },
          watchValidationPassword2: function ($event) {
            return _vm.watchGeneralNestedValidation(
              "password",
              "password2",
              $event
            )
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkBoxArea", class: { isPc: !_vm.isSp } },
        [
          !_vm.isSp
            ? _c(
                "InputLabel",
                { staticClass: "labelArea", class: { isPc: !_vm.isSp } },
                [_vm._v(" お知らせ ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("CheckboxWithLabel", {
                ref: "myCheckbox",
                class: { isPc: !_vm.isSp },
                attrs: {
                  disabled: false,
                  label: "会員用のメール配信を受け取る",
                  "checkbox-id": "receiveMailMagazineId",
                },
                model: {
                  value: _vm.isReceiveMailMagazine,
                  callback: function ($$v) {
                    _vm.isReceiveMailMagazine = $$v
                  },
                  expression: "isReceiveMailMagazine",
                },
              }),
              _vm._v(" "),
              _c("CaptionText", { staticClass: "captionText" }, [
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "進路検討に役立つ記事やイベント・入試情報などをお送りいたします。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("この設定は後からでも変更可能です。")]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("TermsAndPolicy", { staticClass: "termsAndPolicyComponent" }),
      _vm._v(" "),
      _c("ButtonTypeCustom", {
        staticClass: "registerButton",
        attrs: {
          "button-type": "button",
          "button-text": "上記に同意して会員登録する",
          "button-color": "colorPrimary",
          "button-size": "sizeLarge",
        },
        on: {
          "button-clicked": function ($event) {
            return _vm.postUserData($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }